import { Attributes, System, SystemQueries } from "ecsy";
import { LifeTimeData } from "../DataComponents/LifeTimeData";
import { MassData } from "../DataComponents/MassData";
import { RotationData } from "../DataComponents/RotationData";
import { TransformData } from "../DataComponents/TransformData";
import { VelocityData } from "../DataComponents/VelocityData";
import { Vector2 } from "../Math/Vector2";
import { BallTag } from "../TagComponents/BallTag";
import { SpawnBallTag } from "../TagComponents/SpawnBallTag";

const ballMass = 1;
const ballSpeed = 100;
const ballLifeTime = 5;

const spawnInterval = 0.001;
const randomAngle = (5 / 360) * Math.PI * 2;

export class SpawnBallSystem extends System {
  static queries: SystemQueries = {
    spawnPoints: {
      components: [SpawnBallTag, TransformData, RotationData],
    },
  };

  timer: number = 0;

  execute(delta: number, time: number): void {
    this.timer += delta;
    if (this.timer > spawnInterval) {
      const spawnPoints = this.queries.spawnPoints.results;
      spawnPoints.forEach((spawnPoint) => {
        const spawnPointTransform = spawnPoint.getComponent(TransformData);
        const spawnPointRotation = spawnPoint.getComponent(RotationData);

        const spawnRotation =
          spawnPointRotation.rotation + randomAngle * (Math.random() - 0.5);

        const ballEntity = this.world.createEntity();
        ballEntity
          .addComponent(BallTag)
          .addComponent(TransformData, {
            position: new Vector2(
              spawnPointTransform.position.x,
              spawnPointTransform.position.y
            ),
          })
          .addComponent(RotationData, {
            rotation: 0,
          })
          .addComponent(MassData, {
            mass: ballMass,
          })
          .addComponent(VelocityData, {
            velocity: new Vector2(
              Math.cos(spawnRotation) * ballSpeed,
              Math.sin(spawnRotation) * ballSpeed
            ),
          })
          .addComponent(LifeTimeData, {
            lifeTime: ballLifeTime,
          });
      });

      this.timer = 0;
    }
  }
}
